// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BasicAssetsSubform_ValuationFragment = { __typename?: 'AssetValuationV2', id: string, fixedValuationAmount?: CurrencyUSD | null, effectiveDate: Time, description?: string | null, documents?: Array<{ __typename?: 'Document', id: string }> | null };

export type BasicAssetsSubform_AccountFragment = { __typename?: 'Account', id: string, valuations: { __typename?: 'AssetValuationV2Connection', edges?: Array<{ __typename?: 'AssetValuationV2Edge', node?: (
        { __typename?: 'AssetValuationV2' }
        & BasicAssetsSubform_ValuationFragment
      ) | null } | null> | null }, initialValuation?: (
    { __typename?: 'AssetValuationV2' }
    & BasicAssetsSubform_ValuationFragment
  ) | null };

export type IrrevocableTrustBasicAssetsFragment = { __typename?: 'IrrevocableTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type RevocableTrustBasicAssetsFragment = { __typename?: 'RevocableTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type SlatTrustBasicAssetsFragment = { __typename?: 'SLATTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type IlitTrustBasicAssetsFragment = { __typename?: 'ILITTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type GratTrustBasicAssetsFragment = { __typename?: 'GRATTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type QprtTrustBasicAssetsFragment = { __typename?: 'QPRTTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type IndividualPersonalAccountBasicAssetsFragment = { __typename?: 'IndividualPersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type JointPersonalAccountBasicAssetsFragment = { __typename?: 'JointPersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type InsurancePersonalAccountBasicAssetsFragment = { __typename?: 'InsurancePersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type QualifiedTuitionPersonalAccountBasicAssetsFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type RetirementPersonalAccountBasicAssetsFragment = { __typename?: 'RetirementPersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type CustodialPersonalAccountBasicAssetsFragment = { __typename?: 'CustodialPersonalAccount', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type CltTrustBasicAssetsFragment = { __typename?: 'CLTTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type CrtTrustBasicAssetsFragment = { __typename?: 'CRTTrust', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type DonorAdvisedFundBasicAssetsFragment = { __typename?: 'DonorAdvisedFund', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type PrivateFoundationBasicAssetsFragment = { __typename?: 'PrivateFoundation', id: string, designerAccount?: (
    { __typename?: 'Account' }
    & BasicAssetsSubform_AccountFragment
  ) | null };

export type BasicAssets_EntityFragment = { __typename?: 'Entity', id: string, addeparLinkedToNongrantorEntity?: boolean | null, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string }> | null, subtype: { __typename?: 'CCorpBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } | (
    { __typename?: 'CLTTrust' }
    & CltTrustBasicAssetsFragment
  ) | (
    { __typename?: 'CRTTrust' }
    & CrtTrustBasicAssetsFragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & CustodialPersonalAccountBasicAssetsFragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & DonorAdvisedFundBasicAssetsFragment
  ) | { __typename?: 'GPBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } | (
    { __typename?: 'GRATTrust' }
    & GratTrustBasicAssetsFragment
  ) | (
    { __typename?: 'ILITTrust' }
    & IlitTrustBasicAssetsFragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & IndividualPersonalAccountBasicAssetsFragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & InsurancePersonalAccountBasicAssetsFragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & IrrevocableTrustBasicAssetsFragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & JointPersonalAccountBasicAssetsFragment
  ) | { __typename?: 'LLCBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'LPBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } | (
    { __typename?: 'PrivateFoundation' }
    & PrivateFoundationBasicAssetsFragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & QprtTrustBasicAssetsFragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & QualifiedTuitionPersonalAccountBasicAssetsFragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & RetirementPersonalAccountBasicAssetsFragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & RevocableTrustBasicAssetsFragment
  ) | { __typename?: 'SCorpBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } | (
    { __typename?: 'SLATTrust' }
    & SlatTrustBasicAssetsFragment
  ) | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, designerAccount?: (
      { __typename?: 'Account' }
      & BasicAssetsSubform_AccountFragment
    ) | null } };

export type GetBasicAssetsQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type GetBasicAssetsQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | (
    { __typename?: 'Entity' }
    & BasicAssets_EntityFragment
  ) | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export const Operations = {
  Query: {
    GetBasicAssets: 'GetBasicAssets' as const
  },
  Fragment: {
    BasicAssetsSubform_Valuation: 'BasicAssetsSubform_Valuation' as const,
    BasicAssetsSubform_Account: 'BasicAssetsSubform_Account' as const,
    IrrevocableTrustBasicAssets: 'IrrevocableTrustBasicAssets' as const,
    RevocableTrustBasicAssets: 'RevocableTrustBasicAssets' as const,
    SLATTrustBasicAssets: 'SLATTrustBasicAssets' as const,
    ILITTrustBasicAssets: 'ILITTrustBasicAssets' as const,
    GRATTrustBasicAssets: 'GRATTrustBasicAssets' as const,
    QPRTTrustBasicAssets: 'QPRTTrustBasicAssets' as const,
    IndividualPersonalAccountBasicAssets: 'IndividualPersonalAccountBasicAssets' as const,
    JointPersonalAccountBasicAssets: 'JointPersonalAccountBasicAssets' as const,
    InsurancePersonalAccountBasicAssets: 'InsurancePersonalAccountBasicAssets' as const,
    QualifiedTuitionPersonalAccountBasicAssets: 'QualifiedTuitionPersonalAccountBasicAssets' as const,
    RetirementPersonalAccountBasicAssets: 'RetirementPersonalAccountBasicAssets' as const,
    CustodialPersonalAccountBasicAssets: 'CustodialPersonalAccountBasicAssets' as const,
    CLTTrustBasicAssets: 'CLTTrustBasicAssets' as const,
    CRTTrustBasicAssets: 'CRTTrustBasicAssets' as const,
    DonorAdvisedFundBasicAssets: 'DonorAdvisedFundBasicAssets' as const,
    PrivateFoundationBasicAssets: 'PrivateFoundationBasicAssets' as const,
    BasicAssets_Entity: 'BasicAssets_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const BasicAssetsSubform_ValuationFragmentDoc = gql`
    fragment BasicAssetsSubform_Valuation on AssetValuationV2 {
  id
  fixedValuationAmount
  effectiveDate
  description
  documents {
    id
  }
}
    `;
export const BasicAssetsSubform_AccountFragmentDoc = gql`
    fragment BasicAssetsSubform_Account on Account {
  id
  valuations(
    orderBy: [{field: effective_date, direction: DESC}, {field: created_at, direction: DESC}]
    first: 1
  ) {
    edges {
      node {
        ...BasicAssetsSubform_Valuation
      }
    }
  }
  initialValuation {
    ...BasicAssetsSubform_Valuation
  }
}
    ${BasicAssetsSubform_ValuationFragmentDoc}`;
export const IrrevocableTrustBasicAssetsFragmentDoc = gql`
    fragment IrrevocableTrustBasicAssets on IrrevocableTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const RevocableTrustBasicAssetsFragmentDoc = gql`
    fragment RevocableTrustBasicAssets on RevocableTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const SlatTrustBasicAssetsFragmentDoc = gql`
    fragment SLATTrustBasicAssets on SLATTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const GratTrustBasicAssetsFragmentDoc = gql`
    fragment GRATTrustBasicAssets on GRATTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const IlitTrustBasicAssetsFragmentDoc = gql`
    fragment ILITTrustBasicAssets on ILITTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const QprtTrustBasicAssetsFragmentDoc = gql`
    fragment QPRTTrustBasicAssets on QPRTTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const JointPersonalAccountBasicAssetsFragmentDoc = gql`
    fragment JointPersonalAccountBasicAssets on JointPersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const InsurancePersonalAccountBasicAssetsFragmentDoc = gql`
    fragment InsurancePersonalAccountBasicAssets on InsurancePersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const IndividualPersonalAccountBasicAssetsFragmentDoc = gql`
    fragment IndividualPersonalAccountBasicAssets on IndividualPersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const QualifiedTuitionPersonalAccountBasicAssetsFragmentDoc = gql`
    fragment QualifiedTuitionPersonalAccountBasicAssets on QualifiedTuitionPersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const RetirementPersonalAccountBasicAssetsFragmentDoc = gql`
    fragment RetirementPersonalAccountBasicAssets on RetirementPersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const CustodialPersonalAccountBasicAssetsFragmentDoc = gql`
    fragment CustodialPersonalAccountBasicAssets on CustodialPersonalAccount {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const CltTrustBasicAssetsFragmentDoc = gql`
    fragment CLTTrustBasicAssets on CLTTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const CrtTrustBasicAssetsFragmentDoc = gql`
    fragment CRTTrustBasicAssets on CRTTrust {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const DonorAdvisedFundBasicAssetsFragmentDoc = gql`
    fragment DonorAdvisedFundBasicAssets on DonorAdvisedFund {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const PrivateFoundationBasicAssetsFragmentDoc = gql`
    fragment PrivateFoundationBasicAssets on PrivateFoundation {
  id
  designerAccount {
    ...BasicAssetsSubform_Account
  }
}
    ${BasicAssetsSubform_AccountFragmentDoc}`;
export const BasicAssets_EntityFragmentDoc = gql`
    fragment BasicAssets_Entity on Entity {
  id
  addeparLinkedToNongrantorEntity
  integrationEntities {
    id
    kind
    name
  }
  subtype {
    ...IrrevocableTrustBasicAssets
    ...RevocableTrustBasicAssets
    ...SLATTrustBasicAssets
    ...GRATTrustBasicAssets
    ...ILITTrustBasicAssets
    ...QPRTTrustBasicAssets
    ...JointPersonalAccountBasicAssets
    ...InsurancePersonalAccountBasicAssets
    ...IndividualPersonalAccountBasicAssets
    ...QualifiedTuitionPersonalAccountBasicAssets
    ...RetirementPersonalAccountBasicAssets
    ...CustodialPersonalAccountBasicAssets
    ...CLTTrustBasicAssets
    ...CRTTrustBasicAssets
    ...DonorAdvisedFundBasicAssets
    ...PrivateFoundationBasicAssets
    ... on BusinessEntity {
      id
      designerAccount {
        ...BasicAssetsSubform_Account
      }
    }
  }
}
    ${IrrevocableTrustBasicAssetsFragmentDoc}
${RevocableTrustBasicAssetsFragmentDoc}
${SlatTrustBasicAssetsFragmentDoc}
${GratTrustBasicAssetsFragmentDoc}
${IlitTrustBasicAssetsFragmentDoc}
${QprtTrustBasicAssetsFragmentDoc}
${JointPersonalAccountBasicAssetsFragmentDoc}
${InsurancePersonalAccountBasicAssetsFragmentDoc}
${IndividualPersonalAccountBasicAssetsFragmentDoc}
${QualifiedTuitionPersonalAccountBasicAssetsFragmentDoc}
${RetirementPersonalAccountBasicAssetsFragmentDoc}
${CustodialPersonalAccountBasicAssetsFragmentDoc}
${CltTrustBasicAssetsFragmentDoc}
${CrtTrustBasicAssetsFragmentDoc}
${DonorAdvisedFundBasicAssetsFragmentDoc}
${PrivateFoundationBasicAssetsFragmentDoc}
${BasicAssetsSubform_AccountFragmentDoc}`;
export const GetBasicAssetsDocument = gql`
    query GetBasicAssets($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Entity {
      ...BasicAssets_Entity
    }
  }
}
    ${BasicAssets_EntityFragmentDoc}`;

/**
 * __useGetBasicAssetsQuery__
 *
 * To run a query within a React component, call `useGetBasicAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicAssetsQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetBasicAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>(GetBasicAssetsDocument, withFetchPolicyContext(options));
      }
export function useGetBasicAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>(GetBasicAssetsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetBasicAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>(GetBasicAssetsDocument, withFetchPolicyContext(options));
        }
export type GetBasicAssetsQueryHookResult = ReturnType<typeof useGetBasicAssetsQuery>;
export type GetBasicAssetsLazyQueryHookResult = ReturnType<typeof useGetBasicAssetsLazyQuery>;
export type GetBasicAssetsSuspenseQueryHookResult = ReturnType<typeof useGetBasicAssetsSuspenseQuery>;
export type GetBasicAssetsQueryResult = Apollo.QueryResult<GetBasicAssetsQuery, GetBasicAssetsQueryVariables>;